import { format, parse } from "date-fns";

const formatTime = (timeValue) => {
	if (timeValue === null || timeValue === undefined || timeValue === "") {
		return "";
	}

	const isTimestamp =
		typeof timeValue === "number" ||
		(typeof timeValue === "string" && /^\d+$/.test(timeValue.trim()));

	let normalizedTime = String(timeValue);

	if (isTimestamp) {
		const numericValue = Number(timeValue);
		const timestamp =
			String(Math.trunc(numericValue)).length === 10
				? numericValue * 1000
				: numericValue;

		const date = new Date(timestamp);
		if (Number.isNaN(date.getTime())) {
			return "";
		}

		normalizedTime = date.toLocaleTimeString("en-US");
	}

	const splitTimeString = normalizedTime.split(":");
	if (splitTimeString.length < 2) {
		return normalizedTime;
	}

	return `${splitTimeString[0]}:${splitTimeString[1]}`;
};

export default formatTime;

export const getDisplayTime = (scheduleTime) => {
	if (!scheduleTime) return "";

	let parsedDate;

	try {
		if (typeof scheduleTime === "string") {
			if (/^\d{2}:\d{2}$/.test(scheduleTime)) {
				// Only HH:mm provided → attach today's date
				const today = new Date();
				const composite = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')} ${scheduleTime}`;
				parsedDate = parse(composite, "yyyy-MM-dd HH:mm", new Date());
			} else if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(scheduleTime)) {
				// Full YYYY-MM-DD HH:mm
				parsedDate = parse(scheduleTime, "yyyy-MM-dd HH:mm", new Date());
			} else {
				parsedDate = new Date(scheduleTime); // last resort
			}
		} else if (scheduleTime instanceof Date && !isNaN(scheduleTime.getTime())) {
			parsedDate = scheduleTime;
		}

		if (parsedDate && !isNaN(parsedDate.getTime())) {
			return format(parsedDate, "h:mma");
		}
	} catch (err) {
		console.warn("Failed to parse scheduleTime:", scheduleTime, err);
	}

	return "";
};